<template>
  <button class="btn btn-dark btn-sm mr-2" @click="lockHistory">
    <span v-if="historyLocked"><i class="fas fa-lock"></i></span> Lock history
  </button>
</template>
<script>
  import {mapMutations} from 'vuex'

  export default {
    props: ['startDate', 'endDate'],
    created() {
      this.checkHistoryLock()
    },
    data() {
      return {
        historyLocked: false,
      }
    },
    watch: {
      startDate: function () {
        this.checkHistoryLock()
      },
      endDate: function () {
        this.checkHistoryLock()
      },
      historyLocked: function(value) {
        this.isLocked(value)
      }
    },
    methods: {
      ...mapMutations('history', ['isLocked']),

      lockHistory() {
        if (!confirm('Are you sure? After locking reports will be cached for selected period and will not be updated!')) {
          return;
        }
        this.axios.post('lock', {startDate: this.startDate, endDate: this.endDate}).then(response => {
          this.historyLocked = true
        })
      },
      checkHistoryLock() {
        this.axios.get('lock/isLocked', {params: {startDate: this.startDate, endDate: this.endDate}}).then(response => {
          this.historyLocked = response.data.isLocked
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HistoryLockButton.vue